import {
  AccordionItem,
  List,
  Strong,
  Text,
  TextLink,
} from 'braid-design-system';

import { useLocalized } from 'src/utils/hooks/useLocalized';

export const DataSecurity = () => (
  <AccordionItem id="data-security" label="Data Security">
    <List type="number" start={23}>
      <Text>
        Your network, operating system and the software of your web servers,
        databases, and computer systems (collectively, <Strong>Systems</Strong>)
        must be configured to securely operate your Recruitment Software.{' '}
      </Text>
      <Text>
        You must take reasonable steps to protect the Data from misuse,
        interference, loss and unauthorised access, modification, unlawful use
        or disclosure, accidental loss or destruction, or damage and will secure
        the Data and maintain effective security controls that adhere to the
        standards required by Privacy Laws in order to ensure the safe storage
        and proper use of the Data.
      </Text>
      <Text>
        If you become aware or suspect that there has been any security
        deficiencies, vulnerabilities, intrusions, in, or breaches of, your
        Systems, or unauthorised access to, unauthorised disclosure of, or loss
        of Data (each, an <Strong>Incident</Strong>), you must immediately
        contact us and disclose all information relevant to that actual or
        suspected Incident via our Contact Us form on the Partner Hub at{' '}
        <TextLink href="/contactus">
          {useLocalized({
            AU: 'https://talent.seek.com.au/contactus',
            NZ: 'https://talent.seek.co.nz/contactus',
          })}
        </TextLink>
        . You must cooperate with us in investigating and to immediately correct
        any Incident.
      </Text>
      <Text>
        In the event of an Incident, we reserve the right to temporarily, or
        permanently reduce or restrict your access to the SEEK API until the
        Incident has been remediated.
      </Text>
      <Text>
        In the event of any Incident involving your Recruitment Software and the
        SEEK API, you must not make any public statements in relation to the
        incident without prior written and express permission from us. You must
        assist us in verifying your compliance with our security requirements by
        providing any information about your Recruitment Software and/or Systems
        to us, which may also include access to your Recruitment Software and
        other materials related to your use of the Recruitment Software.
      </Text>
      <Text>
        If we become aware of any fraudulent job applications within your
        Systems, we will notify you. You must work with us to immediately delete
        any fraudulent applications from your Systems.
      </Text>
      <Text>
        If you become aware of any fraudulent or illegal activity involving a
        user within your Systems, you must take steps to suspend or terminate
        that user’s ability to access any of our websites and apps through your
        Recruitment Software.
      </Text>
      <Text>
        On termination or expiry of these Terms for whatever reason, or upon our
        written request at any time, cease and ensure that you and your
        personnel cease to use or process the Data and destroy and/or return
        and/or procure the return of any and all Data in their possession or
        control to us.
      </Text>
    </List>
  </AccordionItem>
);
